import _ from 'lodash';
import { bitArrayToString, mapChunks, padArray } from '../../helpers/ArrayHelpers';
import { decimalToBinaryString } from '../../helpers/NumberHelpers';
var base64UrlCharset = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-', '_'
];
var Base64 = /** @class */ (function () {
    function Base64() {
    }
    /**
     * compress a long binary string (100101101100) to base64url encoded chars
     * the chunk order from right to left equals the character order from right to left
     * ----------
     * sample bits: 100101(l) 101100(s)
     * base64url encoded: ls
     * ==>
     * the first character of the base64encoded string represents the
     * @param bits the bit array
     * @returns base64url encoded string
     */
    Base64.prototype.encodeUrl = function (bits) {
        if (bits.length === 0) {
            return base64UrlCharset[0];
        }
        // ensure the bits length is a multiple of 6
        padArray(bits, 6);
        // map 6 items to the base 64 representation of them
        var base64UrlChars = mapChunks(bits, 6, this.bitChunkToBase64Url);
        // join the base64 chars to a string
        var base64UrlString = base64UrlChars.reverse().join('');
        return base64UrlString;
    };
    Base64.prototype.decodeUrl = function (base64Url) {
        // split into base64Url characters
        var base64UrlChars = base64Url.split('');
        // map character to bit chunk
        var bitChunks = base64UrlChars.reverse().map(this.base64UrlCharToBitChunk);
        // merge the chunks
        var bits = _.flatten(bitChunks);
        // return the bits
        return bits;
    };
    /**
     * the first array element is the first bit (with value 1)
     * the last array element is the sixth bit (with value 32)
     * @param bits the 6 bit chunk
     * @returns base64url character to represent this chunk
     */
    Base64.prototype.bitChunkToBase64Url = function (bits) {
        var bitsString = bitArrayToString(bits);
        // convert binary value to decimal value
        var bitsValue = parseInt(bitsString, 2);
        // access the character of the decimal value
        return base64UrlCharset[bitsValue];
    };
    Base64.prototype.base64UrlCharToBitChunk = function (base64UrlChar) {
        // map the character to the decimal value
        var decimalValue = base64UrlCharset.indexOf(base64UrlChar);
        // throw if the char is not part of charset
        if (decimalValue == -1) {
            throw new Error("the char " + base64UrlChar + " is not a valid base64url char");
        }
        // get binary string
        var binary = decimalToBinaryString(decimalValue, 6);
        // convert to bit chunk
        var bitChunk = binary.split('').reverse().map(function (bit) { return bit === '1'; });
        // return the chunk
        return bitChunk;
    };
    Base64.prototype.isValidBase64UrlString = function (theString) {
        var chars = theString.split('');
        return _.every(chars, function (x) { return base64UrlCharset.includes(x); });
    };
    return Base64;
}());
export default new Base64();
//# sourceMappingURL=Base64.js.map